module.exports = __webpack_public_path__ + "img/agency_title02.a548f7e6.png";